import { baseApi } from './baseApi';

export const contentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listContent: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `content/list?${queryString}` : 'content/list',
        method: 'GET',
      }),
      providesTags: ['Content'],
    }),

    getContent: builder.query({
      query: (contentId) => ({
        url: `content/get/${contentId}`,
        method: 'GET',
      }),
      providesTags: (result, error, contentId) => [{ type: 'Content', id: contentId }],
    }),

    addContent: builder.mutation({
      query: (body) => ({
        url: 'content/create',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Content'],
    }),

    updateContent: builder.mutation({
      query: (body) => ({
        url: 'content/update',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Content', id: body?.id },
        'Content',
      ],
    }),

    deleteContent: builder.mutation({
      query: (contentId) => ({
        url: `content/delete/${contentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Content'],
    }),

    getContentMapConfig: builder.query({
      query: (contentId) => ({
        url: `content/${contentId}/map-config`,
        method: 'GET',
      }),
      providesTags: (result, error, contentId) => [{ type: 'ContentMapConfig', id: contentId }],
    }),

    updateContentMapConfig: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `content/${id}/map-config`,
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'ContentMapConfig', id }],
    }),
  }),
});

export const {
  useListContentQuery,
  useGetContentQuery,
  useAddContentMutation,
  useUpdateContentMutation,
  useDeleteContentMutation,
  useGetContentMapConfigQuery,
  useUpdateContentMapConfigMutation,
} = contentApi;

